import { reloadEditDependencies } from './edit_form_dependencies';

/**
 * Bind cancel button, save-as-lead link, and dependency reload on listing/team/showtime type change.
 * Callbacks: toggleTopMode(popup, mode), and reloadEditDependencies receives form + callbacks via reloadDependencies().
 */
export function initEditFormActions(form, elements, callbacks = {}) {
  const {
    cancelButton,
    listingSelect,
    teamMemberSelect,
    showtimeTypeSelect,
    saveAsLeadLink,
    clearShowtimeInput,
    isLeadInput
  } = elements;
  const popup = form.closest('.js-showing-view-popup');

  const resetSpecialFlags = () => {
    if (clearShowtimeInput) clearShowtimeInput.value = '0';
    if (isLeadInput) isLeadInput.value = '0';
  };

  cancelButton?.addEventListener('click', () => {
    callbacks.toggleTopMode?.(popup, 'readonly');
  });

  saveAsLeadLink?.addEventListener('click', (e) => {
    e.preventDefault();
    form.dataset.submitMode = 'lead';
    if (clearShowtimeInput) clearShowtimeInput.value = '1';
    if (isLeadInput) isLeadInput.value = '1';
    form.requestSubmit();
  });

  const reloadDependencies = () => {
    reloadEditDependencies(form, callbacks);
  };
  listingSelect?.addEventListener('change', reloadDependencies);
  teamMemberSelect?.addEventListener('change', reloadDependencies);
  showtimeTypeSelect?.addEventListener('change', reloadDependencies);

  return { resetSpecialFlags };
}
